import styled from 'styled-components';
import Layout from 'sushiweb/Layout';
import grey from 'sushiweb/tokens/color/grey';
import red from 'sushiweb/tokens/color/red';

export const PolicyContainer = styled.div`
  background: #f8f9fc;
  border: 1px solid #e6e8eb;
  border-radius: 0.8rem;
  padding: 2rem;
  margin-bottom: 2rem;
`;

export const StyledLayout = styled(Layout)`
  margin-bottom: 0;
`;

export const PolicyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
`;

export const PolicyTitle = styled.div`
  font-size: 1.8rem;
  font-weight: 500;
  color: ${grey.z900};
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  border: 0.5px solid ${grey.z300};
  border-radius: 0.8rem;
  padding: 0.8rem 1.2rem;
`;

export const PolicyButton = styled.button`
  background: none;
  border: none;
  color: ${red.z500};
  cursor: pointer;
  font-size: 1.4rem;
  font-weight: 500;
  padding: 0;

  &:hover {
    color: ${red.z600};
  }
`;

export const PolicyDetailsRow = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 3rem;
  align-items: flex-end;
  font-size: 1.4rem;
  color: ${grey.z600};
  flex-wrap: wrap;
`;

export const PolicyDetailItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  color: ${grey.z900};
  font-weight: 500;

  span {
    font-weight: 300;
  }
`;

export const SlotContainer = styled.div`
  border-top: 1px solid #e6e8eb;
  padding-top: 2rem;
  margin-top: 2rem;
  font-size: 1.4rem;
  color: ${grey.z600};
`;

export const SlotHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const SlotTitle = styled.div`
  font-size: 1.6rem;
  font-weight: 500;
  color: ${grey.z900};
  span {
    font-weight: 300;
  }
`;

export const SlotDetailsRow = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 1rem;
  align-items: center;
  font-size: 1.4rem;
  color: ${grey.z900};
  flex-wrap: wrap;
  font-weight: 500;
  padding-left: 3rem;

  span {
    font-weight: 300;
  }
`;

export const ClickableText = styled.span`
  color: ${red.z500};
  padding-bottom: 0.2rem;
  border-bottom: 1px dashed ${red.z500};
  cursor: pointer;

  &:hover {
    color: ${red.z600};
    border-bottom-color: ${red.z600};
  }
`;

export const ModalContentContainer = styled.div`
  width: 40rem;
  max-height: 60vh;
  overflow: auto;
`;

export const ModalHeader = styled.div`
  padding: 1.6rem 2rem;
  border-bottom: 1px solid #e6e8eb;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-size: 1.6rem;
  font-weight: 600;
`;

export const ModalContent = styled.div`
  padding: 1.6rem 2rem;
`;

export const ModalList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const ModalListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: ${({ isLast }) => (isLast ? 'none' : '1px dotted #e6e8eb')};
`;

export const ModalListItemText = styled.span`
  font-size: 1.4rem;
`;

export const ModalFooter = styled.div`
  padding: 1.2rem 2rem;
  border-top: 1px solid #e6e8eb;
  text-align: right;
`;

export const ModalCloseButton = styled.button`
  cursor: pointer;
  border: none;
  background: none;
  color: ${red.z500};
  font-size: 1.4rem;
  font-weight: 500;
`;
